import {Entry, EntryVersion} from 'notebook/ELNConstants';
import DocumentEvaluationUpdater from 'notebook/mediocre/DocumentEvaluationUpdater';
import {DocumentMapper, DocumentTraverser} from 'notebook/mediocre/DocumentTraversal';

export default class EntryUpdater extends DocumentEvaluationUpdater<Entry, EntryVersion> {
  getDoc(item: Entry): EntryVersion {
    return item as unknown as EntryVersion;
  }

  traverse(
    evalTraverser: DocumentTraverser,
    newDoc: EntryVersion,
    oldDoc: EntryVersion | null,
    opts: {} | null
  ): void {
    evalTraverser.walkEntryVersion(newDoc, oldDoc, opts);
  }

  mapDoc(mapper: DocumentMapper, doc: EntryVersion): EntryVersion {
    return mapper.mapEntryVersion(doc, null);
  }

  updatedRoot(root: Entry, doc: EntryVersion): Entry {
    return {...root, ...doc};
  }
}
